import { render, staticRenderFns } from "./AttachFiles.vue?vue&type=template&id=1ca0c567&scoped=true"
import script from "./AttachFiles.vue?vue&type=script&lang=js"
export * from "./AttachFiles.vue?vue&type=script&lang=js"
import style0 from "./AttachFiles.vue?vue&type=style&index=0&id=1ca0c567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca0c567",
  null
  
)

export default component.exports